<div class="table-card groups-card">
  <h4 class="card-title">المجموعات</h4>

  <div class="table-responsive">
    <table class="table table-striped" aria-label="جدول المجموعات">
      <thead>
        <tr>
          <th class="text-right">اسم المجموعة</th>
          <th class="text-center">عدد الأعضاء</th>
          <th class="text-center">عدد الأسئلة</th>
          <th class="text-right">الحالة</th>
        </tr>
      </thead>
      <tbody>
        @for (group of groups; track group.name) {
          <tr>
            <td class="text-right">{{ group.name }}</td>
            <td class="text-center">{{ group.membersCount }}</td>
            <td class="text-center">{{ group.questionsCount }}</td>
            <td class="text-right">
              @if (group.isActive) {
                <span class="status-badge status-active">نشط</span>
              } @else {
                <span class="status-badge status-inactive">غير نشط</span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
